import request from '@/utils/request'

// 提现(必须登录)
export function toWithdrawal(data) {
  return request({
    url: '/app-api/service/wallet/toWithdrawal/v1_0_0',
    method: 'post',
    data: data
  })
}
// 打赏(必须登录)
export function toGive(data) {
  return request({
    url: '/app-api/service/wallet/toGive/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取钱包账单枚举列表(已翻译,直接用,支持未登录)
export function getWalletBillTypeEnums(query) {
  return request({
    url: '/app-api/service/wallet/getWalletBillTypeEnums/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户钱包账单列表(必须登录)
export function getWalletBalanceBillList(query) {
  return request({
    url: '/app-api/service/wallet/getWalletBalanceBillList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取打赏金额配置(支持未登录)
export function getGiveAmountConfig(query) {
  return request({
    url: '/app-api/service/wallet/getGiveAmountConfig/v1_0_0',
    method: 'get',
    params: query
  })
}
//获取用户钱包详情(支持未登录)
export function getUserWalletInfo(query) {
  return request({
    url: '/app-api/service/wallet/getUserWalletInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户钱包列表(支持未登录)
export function getUserWalletList(query) {
  return request({
    url: '/app-api/service/wallet/getUserWalletList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 充值(必须登录)
export function toRecharge(data) {
  return request({
    url: '/app-api/service/wallet/toRecharge/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取充值状态信息(必须登录)
export function getRechargeStatusInfo(query) {
  return request({
    url: '/app-api/service/wallet/getRechargeStatusInfo/v1_0_0',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/qianbao.js